import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CaramelImg from "../FlavorPicker/assets/caramel.jpg";
import ChocolateImg from "../FlavorPicker/assets/choc.jpg";
import PBImg from "../FlavorPicker/assets/chocpb.jpg";
import CinnImg from "../FlavorPicker/assets/cinn.jpg";
import CNCImg from "../FlavorPicker/assets/cnc.jpg";
import Minus from "../FlavorPicker/assets/minus.svg";
import MochaImg from "../FlavorPicker/assets/mocha.jpg";
import Plus from "./assets/plus.svg";
import StrawberryImg from "../FlavorPicker/assets/strawberry.jpg";
import VanillaImg from "../FlavorPicker/assets/vanilla.jpg";
import VarietyImg from "../FlavorPicker/assets/variety.jpg";
const FlavorItemV2 = ({ sku, name, image, quantity, adjustQuantity, disabled }) => {
    return (_jsxs("div", { className: "flex flex-col items-start", children: [_jsxs("div", { style: {
                    maxWidth: "110px",
                    maxHeight: "90px",
                }, className: "relative w-full h-full", children: [_jsx("img", { src: image, alt: "flavor stick", className: "w-full h-full" }), _jsxs("div", { style: {
                            transition: ".5s all",
                            width: quantity > 0 ? "100%" : "32px",
                            borderRadius: "18px",
                            boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2)",
                            bottom: "-5px",
                        }, className: "absolute  flex bg-white items-center justify-between right-0", children: [_jsx("button", { className: quantity > 0
                                    ? "flex border-none bg-transparent outline-none items-center justify-center p-1 cursor-pointer"
                                    : " hidden", onClick: () => adjustQuantity(sku, "decrement"), children: _jsx("img", { src: Minus, alt: "Minus" }) }), _jsx("span", { className: quantity > 0 ? "flex font-rhode" : " hidden", children: quantity }), " ", _jsx("button", { className: "w-4 h-4 border-none bg-transparent outline-none flex items-center justify-center p-1 cursor-pointer", style: {
                                    borderRadius: "50%",
                                }, onClick: () => !disabled && adjustQuantity(sku, "increment"), children: _jsx("img", { style: {
                                        opacity: disabled ? 0.5 : 1,
                                    }, src: Plus, alt: "Plus" }) })] })] }), _jsx("span", { className: "type-body text-left max-w-8 mt-1", children: name })] }));
};
export const flavorData = [
    { sku: "variety", image: VarietyImg, name: "Variety Pack" },
    { sku: "caramel", image: CaramelImg, name: "Sea Salt Caramel" },
    { sku: "chocolate", image: ChocolateImg, name: "Rich Chocolate" },
    { sku: "cinnamon", image: CinnImg, name: "Cinnamon Toast" },
    { sku: "cookies", image: CNCImg, name: "Cookies & Cream" },
    { sku: "mocha", image: MochaImg, name: "Caffè Mocha" },
    { sku: "peanut", image: PBImg, name: "Chocolate Peanut Butter" },
    { sku: "strawberry", image: StrawberryImg, name: "Strawberry Cream" },
    { sku: "vanilla", image: VanillaImg, name: "Madagascar Vanilla" },
];
const FlavorPickerV2 = ({ updateValues, values, maxItems = 2, text }) => {
    const total = Object.values(values).reduce((acc, curr) => acc + curr, 0);
    return (_jsx("div", { className: "grid grid-cols-3 gap-1 md:flex md:flex-wrap ", children: flavorData.map((flavor) => (_jsx(FlavorItemV2, { sku: flavor.sku, name: flavor.name, image: flavor.image, adjustQuantity: updateValues, quantity: values[flavor.sku] || 0, disabled: total >= maxItems }, flavor.sku))) }));
};
export default FlavorPickerV2;
